<template>
  <div class="page noselect" :class="{withSearchbar: $store.getters.searchIsRenderedNow}">
    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <div class="spacer-25"></div>

    <!--        <h2 class="text-center">Getränke</h2>-->

    <DrinkCards :show-alternative="true" :lastGotoFoods="true"></DrinkCards>

    <div class="pt-10 text-center" v-if="$store.getters.isKiosk">
      <v-btn class="btn-df scale12" rounded @click.native.passive="$ebus.$emit('resetKioskReload')">
        NEU STARTEN
      </v-btn>
    </div>

    <FixBasket></FixBasket>

  </div>
</template>

<script>
// import store from '../store/store'
// import {ebus} from '../vendor/ebus';
// import * as qconst from '../vendor/qconstants';
// import * as util from '../vendor/util'
// import{logPageView} from "../firebase/firebaseUtil";
// import {offerMixin} from "../mixins/offerMixin";
import CategoryCard from "../components/CategoryCard";
// import FixBasket from "../components/FixBasket";
import DrinkCards from "../components/DrinkCards";
import FixBasket from "../components/FixBasket";

export default {
  name: "Getraenke",
  components: {
    FixBasket, DrinkCards,
    // FixBasket,
    CategoryCard
  },
  // activated() {
  // logPageView('Sortiment')
  // }
}
</script>

<style scoped lang="scss">

</style>
